module.exports = __webpack_public_path__ + "media/src/assets/images/computer-software-industry-f7c62bf5902466cd51cf65e741415929.svg";